import { Component, HostBinding } from '@angular/core';

import version from '../../../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @HostBinding('class') classes = 'main-footer';
  get currentYear() {
    return new Date().getFullYear();
  }

  get currentAppVersion() {
    return version.version;
  }
}
